<template>
  <div v-if="getPermission.si.view">

    <md-tabs md-sync-route class="si-tab">
      <md-tab id="tab-si-header" md-label="Header" to="/si/headers"></md-tab>
      <md-tab id="tab-si-item" md-label="Item" to="/si/items"></md-tab>
      
    </md-tabs>
    <router-view/>

  </div>
</template>

<style lang="scss">
  .do-tab {
    .md-tabs-navigation {
      .md-theme-default {
        height: 25px;
      }
    }
  }
</style>

<script>
  import { mapGetters } from 'vuex';

  


  export default {
    data: () => ({}),
    computed: {
      ...mapGetters([
        'getPermission',
        'getMasterDataName',
      ]),
    },
  };

</script>
